import React from "react";
import "./ResourceSubpage.css";
import resourceImg4 from "../../Images/resourceImg4.webp";
import resourceImg5 from "../../Images/resourceImg5.webp";
import resourceImg6 from "../../Images/resourceImg6.webp";

const ResourceBlog = () => {
  return (
    <div className="resourceBlog">
      <section className="blog1Container">
        <h2>How to Optimize Your LinkedIn Profile</h2>
        <div className="blogBlock1">
          <div className="blog1Text">
            <h3>Professional Profile Photo</h3>
            <ul>
              <li>
                Use a clear, high-resolution headshot with a neutral background
              </li>
              <li>Dress as you would for an interview</li>
              <li>Profiles with photos get 14x more views</li>
            </ul>
            <h3>Compelling Headline</h3>
            <ul>
              <li>
                Go beyond your title—highlight your skills or career goals
                Example: Aspiring Data Analyst | Python & SQL | Passionate About
                Turning Data into Decisions
              </li>
            </ul>
            <h3>Powerful Summary (About Section)</h3>
            <ul>
              <li>
                Write in first person and tell your story: who you are, what
                you’re passionate about, and what you’re looking for
              </li>
              <li>
                Include keywords relevant to your target roles (e.g., “digital
                marketing,” “JavaScript,” “UX research”)
              </li>
            </ul>
            <h3>Experience Section</h3>
            <ul>
              <li>
                List internships, freelance work, volunteer roles, or academic
                projects
              </li>
              <li>
                Use action verbs and quantify results when possible Example: Led
                a team of 4 to build a React.js SPA for an edtech platform,
                improving user engagement by 30%
              </li>
            </ul>
          </div>
          <img src={resourceImg5} alt="resourceImg1" />
        </div>
        <div className="blogBlock1">
          <img src={resourceImg6} alt="resourceImg1" />
          <div className="blog1Text">
            <h3>Skills & Endorsements</h3>
            <ul>
              <li>
                Add at least 10 relevant skills (LinkedIn allows up to 50)
              </li>
              <li>
                Prioritize skills that match job descriptions in your field
              </li>
            </ul>
            <h3>Education & Certifications</h3>
            <ul>
              <li>
                Include degrees, online courses, bootcamps, and certifications
              </li>
              <li>
                Mention achievements like scholarships, competitions, or
                leadership roles
              </li>
            </ul>
            <h3>Custom URL</h3>
            <ul>
              <li>
                Edit your LinkedIn URL to something clean and professional:{" "}
                <br />
                Example: linkedin.com/in/yourname
              </li>
            </ul>
            <h3>Engage & Network</h3>
            <ul>
              <li>
                Follow companies, join industry groups, and comment on posts
              </li>
              <li>
                Share your own insights, projects, or achievements to stay
                visible
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="blog2Container">
        <h2>Get Your Software Developer Resume Noticed</h2>
        <div className="blog2Part">
          <div className="blog2Text">
            <p>
              <b>Start Strong:</b> Use a clear objective and include your
              GitHub, LinkedIn, and portfolio links.
            </p>
            <p>
              <b>Show Skills Clearly:</b> Group languages, frameworks, and tools
              for easy scanning.
            </p>
            <p>
              <b>Highlight Projects:</b> Share academic or personal projects
              with impact metrics.
            </p>
            <p>
              <b>Keep It Clean:</b> One-page PDF, simple fonts, and keyword-rich
              content.
            </p>
            <p>
              <b>Bonus:</b> Add certifications, tailor for each job, and ask
              mentors for feedback.
            </p>
          </div>
          <img src={resourceImg4} alt="resourceImg1" />
        </div>
      </section>
      <section className="blog3Container">
        <h2>Final Round Interview: What to Expect</h2>
        <div className="blog3Text">
          <div className="blog3Text1">
            <h3>What Makes the Final Round Different?</h3>
            <p>
              <b>Decision Makers Are in the Room:</b> Expect to meet senior
              leaders, department heads, or even the CEO. They’re evaluating
              your long-term potential and cultural fit—not just your skills.
            </p>
            <p>
              <b>Deeper Questions:</b> You’ll face behavioral and strategic
              questions like:
              <ul>
                <li>“What motivates you?”</li>
                <li>“How do you handle failure?”</li>
                <li>“Where do you see yourself in five years?”</li>
              </ul>
            </p>
            <p>
              <b>Company Alignment:</b> They want to know if you understand
              their mission, values, and future direction. Research thoroughly
              and tailor your responses.
            </p>
          </div>
          <div className="blog3Text1">
            <h3>How to Prepare</h3>
            <p>
              <b>Know Your Story:</b> Be ready to talk about your journey,
              challenges, and achievements with clarity and confidence.
            </p>
            <p>
              <b>Ask Smart Questions:</b> Prepare thoughtful questions that show
              you’re invested in the company’s growth.
            </p>
            <p>
              <b>Stay Professional:</b> Dress appropriately, be punctual, and
              follow up with a thank-you note.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResourceBlog;
